import React, { useState } from 'react';
import { Button, Input, Form, Select, Row, Col, Typography, DatePicker } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { TableCustom } from '../../../components/TableCustom';
import { useQuery } from '@tanstack/react-query';
import { getListPremiumsRequest } from '../../../services/cms/premiumServiceRequest';
import { listAllActiveServicesRequest } from '../../../services/cms/serviceServiceRequest';
import { getPremiumOrderOptionsRequest } from '../../../services/cms/premiumOrderServiceRequest';
import { newObjectKeys } from '../../../utils/utility';

const { Text } = Typography;

const QuanLyPremium = () => {
  const [formSearch] = Form.useForm();
  const [params, setParams] = useState({ page: 1, limit: 20 });

  const { data: dataPremiums } = useQuery({
    queryKey: ['dataPremiums', params],
    queryFn: () => getListPremiumsRequest(params),
  });

  const { data: activeServices } = useQuery({
    queryKey: ['allActiveServicesForPremiumUser'],
    queryFn: () => listAllActiveServicesRequest({}),
  });

  const { data: orderOptions } = useQuery({
    queryKey: ['premiumOrderOptionsForFilter'],
    queryFn: () => getPremiumOrderOptionsRequest({}),
  });

  const handleSubmitForm = (values) => {
    const temp = { page: 1, limit: params.limit };
    if (values?.user_id) Object.assign(temp, { user_id: values.user_id });
    if (values?.premium_groups) Object.assign(temp, { premium_groups: values.premium_groups });
    if (values?.date_from) Object.assign(temp, { date_from: values.date_from.format('YYYY-MM-DD') });
    if (values?.date_to) Object.assign(temp, { date_to: values.date_to.format('YYYY-MM-DD') });
    if (values?.phone) Object.assign(temp, { phone: values.phone });
    if (values?.end_time) Object.assign(temp, { end_time: values.end_time.format('YYYY-MM-DD') });
    if (values?.modify_by) Object.assign(temp, { modify_by: values.modify_by });
    setParams(temp);
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'User ID', dataIndex: 'user_id', key: 'user_id', render: (id) => (id ? <Link to={`/cms/quan-ly-user/${id}`} className="text-blue-600 hover:text-blue-800 font-bold">{id}</Link> : '-') },
    { title: 'Gói', dataIndex: 'premium_type_name', key: 'premium_type_name' },
    { title: 'Dịch vụ', dataIndex: 'service_name', key: 'service_name' },
    { title: 'Thời gian bắt đầu', dataIndex: 'start_time', key: 'start_time' },
    { title: 'Thời gian kết thúc', dataIndex: 'end_time', key: 'end_time' },
  ];

  const staffOptions = orderOptions?.staff?.map(s => ({ value: s.id, label: s.username })) || [];

  return (
    <div className="m-5">
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-2xl">Quản lý Premium User</h1>
      </div>
      <Form name="search_premiums" form={formSearch} layout="vertical" requiredMark={false} className="mb-5" onFinish={handleSubmitForm}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="user_id" label={<Text>User ID</Text>}>
              <Input placeholder="Nhập User ID" type="number" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="phone" label={<Text>Số điện thoại</Text>}>
              <Input placeholder="Số điện thoại" allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="premium_groups" label={<Text>Dịch vụ</Text>}>
              <Select showSearch allowClear placeholder="Chọn dịch vụ"
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={activeServices?.map(s => ({ value: s.id, label: s.name })) || []}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="modify_by" label={<Text>Nhân viên</Text>}>
              <Select showSearch allowClear placeholder="Chọn nhân viên"
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={staffOptions}
              />
            </Form.Item>
          </Col>
          {/* Giống CMS cũ: Từ ngày/Đến ngày lọc theo ngày gia hạn (renewal_date) */}
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="date_from" label={<Text>Từ ngày</Text>}>
              <DatePicker format="DD/MM/YYYY" className="w-full" placeholder="Từ ngày" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="date_to" label={<Text>Đến ngày</Text>}>
              <DatePicker format="DD/MM/YYYY" className="w-full" placeholder="Đến ngày" />
            </Form.Item>
          </Col>
          {/* Giống CMS cũ: còn hạn từ cuối ngày này trở đi */}
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="end_time" label={<Text>Ngày hết hạn</Text>}>
              <DatePicker format="DD/MM/YYYY" className="w-full" placeholder="Ngày hết hạn" />
            </Form.Item>
          </Col>
          <Col className="flex items-center gap-2" xs={24} style={{ marginTop: 12 }}>
            <Button type="primary" htmlType="submit"><SearchOutlined /> Tìm kiếm</Button>
            {params && Object.values(newObjectKeys(params, ['user_id', 'phone', 'premium_groups', 'date_from', 'date_to', 'end_time', 'modify_by'])).some((value) => value) && (
              <Button htmlType="button" onClick={() => { formSearch.resetFields(); setParams({ page: 1, limit: params.limit }); }}>
                <DeleteOutlined /> Xóa lọc
              </Button>
            )}
          </Col>
        </Row>
      </Form>
      <TableCustom columns={columns} dataSource={dataPremiums?.data} totalItem={dataPremiums?.total} params={params} setParams={setParams} />
    </div>
  );
};

export default QuanLyPremium;
